var map = {
	"./Angular.png": 170,
	"./Java.png": 638,
	"./Javascript.png": 286,
	"./NET.png": 428,
	"./Python.png": 285,
	"./React.png": 616,
	"./SAP.png": 268,
	"./SQL.png": 859
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 192;